module.exports = __webpack_public_path__ + "static/media/attr_opd.9d4ba5c7.svg";